// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  padding-top: 40px;
  overflow-y: auto;
}

.checkout-modal {
  background: #FAF6E7;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  outline: none;
  pointer-events: auto;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.checkout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 2px solid #E8D5B7;
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  border-radius: 16px 16px 0 0;
}

.checkout-header h2 {
  color: #FAF6E7;
  font-size: 1.75rem;
  margin: 0;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
}

.checkout-close-btn {
  background: none;
  border: none;
  color: #FAF6E7;
  font-size: 2rem;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
}

.checkout-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.checkout-content {
  padding: 28px;
}

.checkout-summary {
  background: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 28px;
  text-align: center;
  border: 2px solid #E8D5B7;
}

.checkout-summary h3 {
  margin: 0 0 12px 0;
  color: #3D1818;
  font-size: 1.1rem;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
}

.checkout-total {
  font-size: 2rem;
  color: #3D1818;
  font-weight: 700;
  margin: 0;
}

.checkout-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.delivery-methods {
  margin-bottom: 8px;
}

.delivery-methods h3 {
  color: #3D1818;
  font-size: 1.1rem;
  margin: 0 0 16px 0;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
}

.delivery-option {
  display: block;
  position: relative;
  padding: 16px;
  border: 2px solid #E8D5B7;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.delivery-option:hover {
  border-color: #3D1818;
  box-shadow: 0 2px 8px rgba(61, 24, 24, 0.1);
}

.delivery-option.selected {
  border-color: #3D1818;
  background: rgba(61, 24, 24, 0.02);
  box-shadow: 0 0 0 3px rgba(61, 24, 24, 0.1);
}

.delivery-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.delivery-option-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.delivery-option-title {
  color: #3D1818;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.delivery-price {
  color: #7B2323;
  font-size: 0.9rem;
  font-weight: 500;
}

.delivery-option-description {
  color: #5D3A3A;
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group label {
  color: #3D1818;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: 'Playfair Display', serif;
}

.required {
  color: #C83232;
}

.form-group input,
.form-group textarea,
.form-group select {
  padding: 12px 16px;
  border: 2px solid #E8D5B7;
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  background: white;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group select {
  cursor: pointer;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #3D1818;
  box-shadow: 0 0 0 3px rgba(61, 24, 24, 0.1);
}

.form-group input.error,
.form-group textarea.error,
.form-group select.error {
  border-color: #C83232;
}

.form-group input.error:focus,
.form-group textarea.error:focus,
.form-group select.error:focus {
  box-shadow: 0 0 0 3px rgba(200, 50, 50, 0.1);
}

.error-message {
  color: #C83232;
  font-size: 0.85rem;
  margin-top: -2px;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

/* Econt Dropdown Styles */
.form-group select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.form-group select option.city-separator {
  background-color: #e0e0e0;
  color: #666;
  font-weight: normal;
  padding: 4px 8px;
  text-align: center;
  cursor: default;
}

.checkout-submit-btn {
  margin-top: 12px;
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);
}

.checkout-submit-btn:hover {
  background: linear-gradient(135deg, #5D3A3A 0%, #7B4646 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(61, 24, 24, 0.4);
}

.checkout-submit-btn:active {
  transform: translateY(0);
}

.checkout-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: linear-gradient(135deg, #6D6D6D 0%, #5D5D5D 100%);
}

.checkout-submit-btn:disabled:hover {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);
}

/* Success Modal */
.success-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10100;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.success-modal-content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUpFade 0.3s ease-out;
}

@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  animation: scaleIn 0.4s ease-out 0.2s both;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.success-icon svg {
  width: 100%;
  height: 100%;
}

.success-modal-content h2 {
  color: #3D1818;
  font-size: 1.75rem;
  margin: 0 0 16px 0;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
}

.success-modal-content p {
  color: #5D3A3A;
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0 0 32px 0;
}

.success-ok-btn {
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 48px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);
}

.success-ok-btn:hover {
  background: linear-gradient(135deg, #5D3A3A 0%, #7B4646 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(61, 24, 24, 0.4);
}

.success-ok-btn:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 768px) {
  .checkout-modal-overlay {
    padding: 0;
    padding-top: 0;
    align-items: flex-start;
  }

  .checkout-modal {
    max-width: 100%;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }

  .checkout-header {
    padding: 20px 24px;
    border-radius: 0;
    flex-shrink: 0;
  }

  .checkout-header h2 {
    font-size: 1.5rem;
  }

  .checkout-content {
    padding: 24px 20px;
    flex: 1;
    overflow-y: auto;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .checkout-total {
    font-size: 1.75rem;
  }

  .success-modal-content {
    padding: 32px 24px;
  }

  .success-modal-content h2 {
    font-size: 1.5rem;
  }

  .success-modal-content p {
    font-size: 1rem;
  }

  .success-icon {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 480px) {
  .checkout-header {
    padding: 16px 20px;
  }

  .checkout-header h2 {
    font-size: 1.3rem;
  }

  .checkout-content {
    padding: 20px 16px;
  }

  .checkout-summary {
    padding: 16px;
    margin-bottom: 20px;
  }

  .checkout-total {
    font-size: 1.5rem;
  }

  .delivery-option {
    padding: 12px;
  }

  .delivery-option-title {
    font-size: 0.95rem;
  }

  .delivery-price {
    font-size: 0.85rem;
  }

  .checkout-submit-btn {
    font-size: 1rem;
    padding: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/CheckoutModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".checkout-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n  padding-top: 40px;\n  overflow-y: auto;\n}\n\n.checkout-modal {\n  background: #FAF6E7;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease-out;\n  outline: none;\n  pointer-events: auto;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.checkout-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px;\n  border-bottom: 2px solid #E8D5B7;\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  border-radius: 16px 16px 0 0;\n}\n\n.checkout-header h2 {\n  color: #FAF6E7;\n  font-size: 1.75rem;\n  margin: 0;\n  font-family: 'Playfair Display', serif;\n  font-weight: 600;\n}\n\n.checkout-close-btn {\n  background: none;\n  border: none;\n  color: #FAF6E7;\n  font-size: 2rem;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n}\n\n.checkout-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.checkout-content {\n  padding: 28px;\n}\n\n.checkout-summary {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 28px;\n  text-align: center;\n  border: 2px solid #E8D5B7;\n}\n\n.checkout-summary h3 {\n  margin: 0 0 12px 0;\n  color: #3D1818;\n  font-size: 1.1rem;\n  font-family: 'Playfair Display', serif;\n  font-weight: 600;\n}\n\n.checkout-total {\n  font-size: 2rem;\n  color: #3D1818;\n  font-weight: 700;\n  margin: 0;\n}\n\n.checkout-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.delivery-methods {\n  margin-bottom: 8px;\n}\n\n.delivery-methods h3 {\n  color: #3D1818;\n  font-size: 1.1rem;\n  margin: 0 0 16px 0;\n  font-family: 'Playfair Display', serif;\n  font-weight: 600;\n}\n\n.delivery-option {\n  display: block;\n  position: relative;\n  padding: 16px;\n  border: 2px solid #E8D5B7;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.delivery-option:hover {\n  border-color: #3D1818;\n  box-shadow: 0 2px 8px rgba(61, 24, 24, 0.1);\n}\n\n.delivery-option.selected {\n  border-color: #3D1818;\n  background: rgba(61, 24, 24, 0.02);\n  box-shadow: 0 0 0 3px rgba(61, 24, 24, 0.1);\n}\n\n.delivery-option input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.delivery-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.delivery-option-title {\n  color: #3D1818;\n  font-size: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.delivery-price {\n  color: #7B2323;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.delivery-option-description {\n  color: #5D3A3A;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group label {\n  color: #3D1818;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: 'Playfair Display', serif;\n}\n\n.required {\n  color: #C83232;\n}\n\n.form-group input,\n.form-group textarea,\n.form-group select {\n  padding: 12px 16px;\n  border: 2px solid #E8D5B7;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: inherit;\n  background: white;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-group select {\n  cursor: pointer;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #3D1818;\n  box-shadow: 0 0 0 3px rgba(61, 24, 24, 0.1);\n}\n\n.form-group input.error,\n.form-group textarea.error,\n.form-group select.error {\n  border-color: #C83232;\n}\n\n.form-group input.error:focus,\n.form-group textarea.error:focus,\n.form-group select.error:focus {\n  box-shadow: 0 0 0 3px rgba(200, 50, 50, 0.1);\n}\n\n.error-message {\n  color: #C83232;\n  font-size: 0.85rem;\n  margin-top: -2px;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Econt Dropdown Styles */\n.form-group select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.form-group select option.city-separator {\n  background-color: #e0e0e0;\n  color: #666;\n  font-weight: normal;\n  padding: 4px 8px;\n  text-align: center;\n  cursor: default;\n}\n\n.checkout-submit-btn {\n  margin-top: 12px;\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);\n}\n\n.checkout-submit-btn:hover {\n  background: linear-gradient(135deg, #5D3A3A 0%, #7B4646 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(61, 24, 24, 0.4);\n}\n\n.checkout-submit-btn:active {\n  transform: translateY(0);\n}\n\n.checkout-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #6D6D6D 0%, #5D5D5D 100%);\n}\n\n.checkout-submit-btn:disabled:hover {\n  transform: translateY(0);\n  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);\n}\n\n/* Success Modal */\n.success-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10100;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.success-modal-content {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  max-width: 500px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUpFade 0.3s ease-out;\n}\n\n@keyframes slideUpFade {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px;\n  animation: scaleIn 0.4s ease-out 0.2s both;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n.success-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.success-modal-content h2 {\n  color: #3D1818;\n  font-size: 1.75rem;\n  margin: 0 0 16px 0;\n  font-family: 'Playfair Display', serif;\n  font-weight: 600;\n}\n\n.success-modal-content p {\n  color: #5D3A3A;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin: 0 0 32px 0;\n}\n\n.success-ok-btn {\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 14px 48px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 4px 12px rgba(61, 24, 24, 0.3);\n}\n\n.success-ok-btn:hover {\n  background: linear-gradient(135deg, #5D3A3A 0%, #7B4646 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(61, 24, 24, 0.4);\n}\n\n.success-ok-btn:active {\n  transform: translateY(0);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .checkout-modal-overlay {\n    padding: 0;\n    padding-top: 0;\n    align-items: flex-start;\n  }\n\n  .checkout-modal {\n    max-width: 100%;\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .checkout-header {\n    padding: 20px 24px;\n    border-radius: 0;\n    flex-shrink: 0;\n  }\n\n  .checkout-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .checkout-content {\n    padding: 24px 20px;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .checkout-total {\n    font-size: 1.75rem;\n  }\n\n  .success-modal-content {\n    padding: 32px 24px;\n  }\n\n  .success-modal-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .success-modal-content p {\n    font-size: 1rem;\n  }\n\n  .success-icon {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n@media (max-width: 480px) {\n  .checkout-header {\n    padding: 16px 20px;\n  }\n\n  .checkout-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .checkout-content {\n    padding: 20px 16px;\n  }\n\n  .checkout-summary {\n    padding: 16px;\n    margin-bottom: 20px;\n  }\n\n  .checkout-total {\n    font-size: 1.5rem;\n  }\n\n  .delivery-option {\n    padding: 12px;\n  }\n\n  .delivery-option-title {\n    font-size: 0.95rem;\n  }\n\n  .delivery-price {\n    font-size: 0.85rem;\n  }\n\n  .checkout-submit-btn {\n    font-size: 1rem;\n    padding: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
